<template>
  <div class="loading-wrapper">
    <div class="card">
      <img src="../assets/img/swirl.svg" alt="rotating swirl" />
      <div v-if="progress">{{ progress }}</div>
      <div v-if="progress === 'File upload progress: 100%'">Encrypting your data</div>
      <div v-else-if="progress === 'File download progress: 0%'">Decrypting your data</div>
      <div class="loading-text">Watch the swirl</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    progress: String,
    reason: String
  }
};
</script>
<style lang="scss">
.loading-wrapper {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  transition: opacity 0.3s ease;
  .card {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
    width: 50vw;
    img {
      width: 50px;
      margin: 50px;
      animation: spin 1s linear infinite;
    }
    .loading-text {
      padding: 10px;
      margin-bottom: 20px;
    }
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
    transform-origin: 50% 50%;
  }
}

@media screen and (max-width: 700px) {
  .loading-wrapper {
    .card {
      width: 100vw;
    }
  }
}
</style>
